export default __webpack_public_path__ + "static/media/9d.c350e201.png";